import keyBy from 'lodash/keyBy';

export default {
  nodes: state => state.nodes.items,
  activeNodeId: state => state.nodes.active,
  node: state => state.nodes.items[state.nodes.active],
  elementGroups: state => {
    const elementGroupsArr = state.nodes.items[state.nodes.active].element_groups;
    return Array.isArray(elementGroupsArr) && elementGroupsArr.length ? keyBy(elementGroupsArr, 'id') : {} ; 
  },
  next: state => state.nodes.next,
}